import { Handle, Position } from "react-flow-renderer";

function UPCNode({ data }) {
  console.log(data);

  return (
    <div className="upc-node">
      <Handle type="target" position={Position.Left} />
      <label>{data.label}</label>
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default UPCNode;
